export interface PlatformMetricsSummaryApiResource {
  total_workspaces: number;
  active_workspaces: number;
  suspended_workspaces: number;
  total_accounts: number;
  active_accounts: number;
  recent_activity_count: number;
  recent_activity_days: number;
}

export interface PlatformMetricsSummary {
  totalWorkspaces: number;
  activeWorkspaces: number;
  suspendedWorkspaces: number;
  totalAccounts: number;
  activeAccounts: number;
  recentActivityCount: number;
  recentActivityDays: number;
}

export function mapApiResourceToPlatformMetricsSummary(
  resource: PlatformMetricsSummaryApiResource
): PlatformMetricsSummary {
  return {
    totalWorkspaces: resource.total_workspaces,
    activeWorkspaces: resource.active_workspaces,
    suspendedWorkspaces: resource.suspended_workspaces,
    totalAccounts: resource.total_accounts,
    activeAccounts: resource.active_accounts,
    recentActivityCount: resource.recent_activity_count,
    recentActivityDays: resource.recent_activity_days,
  };
}

export interface PlatformGrowthPeriodApiResource {
  period: string;
  new_workspaces: number;
  new_accounts: number;
}

export interface PlatformGrowthApiResource {
  months: number;
  baseline_workspaces: number;
  baseline_accounts: number;
  periods: PlatformGrowthPeriodApiResource[];
}

export interface PlatformGrowthPeriod {
  period: string;
  newWorkspaces: number;
  newAccounts: number;
}

export interface PlatformGrowth {
  months: number;
  baselineWorkspaces: number;
  baselineAccounts: number;
  periods: PlatformGrowthPeriod[];
}

export function mapApiResourceToPlatformGrowth(resource: PlatformGrowthApiResource): PlatformGrowth {
  return {
    months: resource.months,
    baselineWorkspaces: resource.baseline_workspaces,
    baselineAccounts: resource.baseline_accounts,
    periods: resource.periods.map(function mapPeriod(period) {
      return {
        period: period.period,
        newWorkspaces: period.new_workspaces,
        newAccounts: period.new_accounts,
      };
    }),
  };
}

export interface PlatformActivityDayApiResource {
  date: string;
  count: number;
}

export interface PlatformActionCountApiResource {
  action: string;
  count: number;
}

export interface PlatformActivityApiResource {
  days: number;
  daily: PlatformActivityDayApiResource[];
  by_action: PlatformActionCountApiResource[];
}

export interface PlatformActivityDay {
  date: string;
  count: number;
}

export interface PlatformActionCount {
  action: string;
  count: number;
}

export interface PlatformActivity {
  days: number;
  daily: PlatformActivityDay[];
  byAction: PlatformActionCount[];
}

export function mapApiResourceToPlatformActivity(
  resource: PlatformActivityApiResource
): PlatformActivity {
  return {
    days: resource.days,
    daily: resource.daily.map(function mapDay(day) {
      return { date: day.date, count: day.count };
    }),
    byAction: resource.by_action.map(function mapAction(actionCount) {
      return { action: actionCount.action, count: actionCount.count };
    }),
  };
}

export interface PlatformStatusCountApiResource {
  status: string;
  count: number;
}

export interface PlatformTypeCountApiResource {
  type: string;
  count: number;
}

export interface PlatformBreakdownApiResource {
  by_status: PlatformStatusCountApiResource[];
  by_type: PlatformTypeCountApiResource[];
}

export interface PlatformCategoryCount {
  category: string;
  count: number;
}

export interface PlatformBreakdown {
  byStatus: PlatformCategoryCount[];
  byType: PlatformCategoryCount[];
}

export function mapApiResourceToPlatformBreakdown(
  resource: PlatformBreakdownApiResource
): PlatformBreakdown {
  return {
    byStatus: resource.by_status.map(function mapStatus(statusCount) {
      return { category: statusCount.status, count: statusCount.count };
    }),
    byType: resource.by_type.map(function mapType(typeCount) {
      return { category: typeCount.type, count: typeCount.count };
    }),
  };
}
